// @flow
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import Attributes from 'esm-web-pro/components/layout/sidePanel/Attributes';

type Props = {
    providerName: string,
    objectName: string,
    pipeModel: string,
    pipeData: {
        count: string,
        type: string,
        is_virtual: boolean,
    }
};

const PipeAttributes = (props: Props) => {
    const {
        providerName,
        objectName,
        pipeModel,
        pipeData: {
            count, type,
        },
    } = props;

    const attributes = [
        {
            label: <FormattedMessage id="pipe-attributes-provider" defaultMessage="Infrastructure Provider" />,
            value: providerName,
        },
        {
            label: <FormattedMessage id="pipe-attributes-object" defaultMessage="Object" />,
            value: objectName,
        },
    ];

    if (count) {
        attributes.push({
            label: <FormattedMessage id="pipe-attributes-count" defaultMessage="Count" />,
            value: count,
        });
    }

    if (type) {
        attributes.push({
            label: <FormattedMessage id="pipe-attributes-type" defaultMessage="Type" />,
            value: pipeModel,
        });
    }

    return (
        <Attributes attributes={attributes} />
    );
};

export default PipeAttributes;
